import type { SolidOrGradient } from "schemas/solidOrGradient";

export type ReploMixedStyleValue = {
  _reploMixedStyleValue: true;
};

export const REPLO_MIXED_STYLE_VALUE = {
  _reploMixedStyleValue: true,
} satisfies ReploMixedStyleValue;

// oxlint-disable-next-line typescript/no-explicit-any -- legacy any, may or may not be needed
export function isMixedStyleValue(value: any): value is ReploMixedStyleValue {
  return value && typeof value === "object" && "_reploMixedStyleValue" in value;
}

export type GradientOrSolidOnChangeProps =
  | {
      allowsGradientSelection: false;
      onPreviewChange?(value: string | null): void;
      onChange(value: string | null): void;
      value: string | ReploMixedStyleValue | null;
    }
  | {
      allowsGradientSelection: true;
      onPreviewChange?(value: SolidOrGradient): void;
      onChange(value: SolidOrGradient): void;
      value: SolidOrGradient | ReploMixedStyleValue | null;
    };
